import clsx from "clsx";
import styles from "../floorplans.module.scss";

import vtIcon from "../../../assets/images/vt.svg";
import { formatCurrency, getAvailabilityDate } from "../../../utils/util";
import FloorplanSpecialComponent from "./floorplanSpecialComponent";
import VirtualTourPopup from "../virtualTourPopup";
import { useState } from "react";
import { traceEvent, traceFirstMeaningfulAction } from "../../../utils/tracing";

export default function FloorPlanListCard({
  data,
  typeListing,
  fpData,
  specials,
  contactLink,
  params,
  hasAnyVirtualTour,
}) {
  const [isVirtualTourOpen, setIsVirtualTourOpen] = useState(false);

  return (
    <div className={styles.FloorplanListCard}>
      <FloorplanSpecialComponent
        typeListing={typeListing}
      
        specials={specials}
        fpId={fpData?.floorplan_id}
      />
      <a
        href={
          getAvailabilityDate(
            typeListing ? data?.min_availability_date : data?.availability_date,
            typeListing ? data?.status : data?.unit_status
          ) !== ""
            ? typeListing
              ? `/find-your-home/availability/${data?.floorplan_name}/${data?.floorplan_id}${
                  params ? `/?${params}` : ""
                }`
              : `/find-your-home/availability/${fpData?.floorplan_name}/${
                  fpData?.floorplan_id
                }/apartments/${data?.marketing_name}/${data?.unit_number}${
                  params ? `?${params}` : ""
                }`
            : typeListing
            ? `/find-your-home/availability/${data?.floorplan_name}/${data?.floorplan_id}${
                params ? `/?${params}` : ""
              }`
            : typeListing
            ? `/find-your-home/availability/${data?.floorplan_name}/${data?.floorplan_id}${
                params ? `/?${params}` : ""
              }`
            : `/find-your-home/availability/${fpData?.floorplan_name}/${
                fpData?.floorplan_id
              }/apartments/${data?.marketing_name}/${data?.unit_number}${
                  params ? `?${params}` : ""
                }`
        }
      >
        <h3 className={styles.Name}>
          {typeListing ? data?.floorplan_name : data?.marketing_name}
        </h3>
      </a>
      <ul className={styles.Features}>
        <li>
          {data?.bed_count === "0" ? "Studio" : `${data?.bed_count} Bedroom`}
        </li>
        <li>{parseFloat(data?.bath_count)} Bath</li>
      </ul>
      <div className={styles.TwoLineBox}>
        {getAvailabilityDate(
          typeListing ? data?.min_availability_date : data?.availability_date,
          typeListing ? data?.status : data?.unit_status
        ) !== "" ? (
          <>
            Available
            <span>
              {getAvailabilityDate(
                typeListing
                  ? data?.min_availability_date
                  : data?.availability_date,
                typeListing ? data?.status : data?.unit_status
              )}
            </span>
          </>
        ) : (
          <span className={styles.ComingSoon}>Coming Soon</span>
        )}
      </div>
      <div className={styles.TwoLineBox}>
        Price
        <span>
          {typeListing ? (
            parseInt(data?.max_rent) > 0 ? (
              <>
                From <span>{formatCurrency(data?.min_rent)}</span>
              </>
            ) : (
              <span>Call for pricing</span>
            )
          ) : data?.best_price !== null && parseInt(data?.best_price) > 0 ? (
            <>
              From <span>{formatCurrency(data?.best_price)}</span>
            </>
          ) : (
            <span>Call for pricing</span>
          )}
        </span>
      </div>
      <div className={styles.TwoLineBox}>
        Square Footage{" "}
        <span>{typeListing ? data?.min_sqft : data?.sqft} SQ.FT.</span>
      </div>
    
      {hasAnyVirtualTour && (
        <div className={styles.VirtualTourBtn}>
          {data?.virtual_tour_url && (
            <button onClick={() => setIsVirtualTourOpen(true)}>
              Virtual Tour <img src={vtIcon} alt="Virtual Tour" />
            </button>
          )}
        </div>
      )}
     

      {getAvailabilityDate(
        typeListing ? data?.min_availability_date : data?.availability_date,
        typeListing ? data?.status : data?.unit_status
      ) !== "" ? (
        <div className={styles.BtnWrapper}>
          {typeListing ? (
            parseInt(data?.max_rent) > 0 ? (
              <a
                href={data?.availability_url}
                target="_blank"
                rel="noreferrer"
                className={clsx(styles.Btn, styles.primary, "apply-now-btn")}
                onClick={() => { traceFirstMeaningfulAction(); traceEvent(typeListing ? "FLOORPLAN_APPLY_NOW_LANDING" : "FLOORPLAN_UNIT_LISTING_APPLY_NOW"); }}
              >
                Apply Now
              </a>
            ) : (
              <a
                href={contactLink}
                className={clsx(styles.Btn, styles.primary)}
              >
                Get Notified
              </a>
            )
          ) : data?.best_price !== null && parseInt(data?.best_price) > 0 ? (
            <a
              href={`${process.env.REACT_APP_FP_LEASE_TERM_URL}/property[id]/${
                data?.apartment_id
              }/property_floorplan[id]/${fpData?.floorplan_id}/unit_space[id]/${
                data?.unit_space_id
              }/show_in_popup/false/from_check_availability/1/?lease_start_date=${
                new Date() > new Date(data?.availability_date) 
                  ? new Date().toISOString().split('T')[0]
                  : data?.availability_date
              }`}
              target="_blank"
              rel="noreferrer"
              className={clsx(styles.Btn, styles.primary, "apply-now-btn")}
              onClick={() => { traceFirstMeaningfulAction(); traceEvent(typeListing ? "FLOORPLAN_APPLY_NOW_LANDING" : "FLOORPLAN_UNIT_LISTING_APPLY_NOW"); }}
            >
              Apply Now
            </a>
          ) : (
            <a href={contactLink} className={clsx(styles.Btn, styles.primary)}>
              Get Notified
            </a>
          )}
          <a
            href={
              typeListing
                ? `/find-your-home/availability/${data?.floorplan_name}/${data?.floorplan_id}${
                    params ? `/?${params}` : ""
                  }`
                : `/find-your-home/availability/${fpData?.floorplan_name}/${
                    fpData?.floorplan_id
                  }/apartments/${data?.marketing_name}/${data?.unit_number}${
                    params ? `?${params}` : ""
                  }`
            }
            className={clsx(
              styles.Btn,
              styles.secondary,
              typeListing && "floorplans_secondary"
            )}
            onClick={
              !typeListing
                ? () => {
                    traceFirstMeaningfulAction();
                    traceEvent("UNIT_LISTING_VIEW_DETAILS");
                  }
                : () => {
                    traceFirstMeaningfulAction();
                    traceEvent("AVAILABILITY_BTN_CLICK");
                  }
            }
          >
            {typeListing
              ? `Availability (${data?.available_unit_count})`
              : "View Details"}
          </a>
        </div>
      ) : (
        <div className={styles.BtnWrapper}>
          {typeListing ? (
            <a href={contactLink} className={clsx(styles.Btn, styles.primary)}>
              Get Notified
            </a>
          ) : (
            <a
              href={
                typeListing
                  ? `/find-your-home/availability/${data?.floorplan_name}/${
                      data?.floorplan_id
                    }${params ? `/?${params}` : ""}`
                  : `/find-your-home/availability/${fpData?.floorplan_name}/${
                      fpData?.floorplan_id
                    }/apartments/${data?.marketing_name}/${data?.unit_number}${
                      params ? `?${params}` : ""
                    }`
              }
              className={clsx(styles.Btn, styles.primary)}
              onClick={() => { traceFirstMeaningfulAction(); traceEvent("UNIT_LISTING_VIEW_DETAILS"); }}
            >
              {typeListing
                ? `Availability (${data?.available_unit_count})`
                : "View Details"}
            </a>
          )}
          <a
            href={
              typeListing
                ? `/find-your-home/availability/${data?.floorplan_name}/${data?.floorplan_id}${
                    params ? `/?${params}` : ""
                  }`
                : contactLink
            }
            className={clsx(
              styles.Btn,
              styles.secondary,
              styles.fullWidthBtn,
              !typeListing && styles.pricingBtn
            )}
          >
            {typeListing ? `View Units` : "Inquire For Details"}
          </a>
        </div>
      )}
      <VirtualTourPopup
        isOpen={isVirtualTourOpen}
        onClose={() => setIsVirtualTourOpen(false)}
        virtualTourUrl={data?.virtual_tour_url}
      />
    </div>
  );
}
